import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { Car } from '../../../../models/car';

@Component({
  selector: 'app-cars-list-mobile',
  imports: [CommonModule, PaginatorModule],
  templateUrl: './cars-list-mobile.html',
  styleUrl: './cars-list-mobile.scss'
})
export class CarsListMobile {

  @Input() cars: Car[] = [];
  @Input() totalRecords = 0;
  @Input() rows = 20;
  @Input() first = 0;

  @Output() pageChange = new EventEmitter<PaginatorState>();
  @Output() carClick = new EventEmitter<Car>();

  getFuelPct(car: Car): number {
    return Number(car.telemetry?.fuelLevel) || 0;
  }

  getBatteryPct(car: Car): number {
    if (!car.telemetry?.powerSupplyVoltage) return 0;
    return Math.min((car.telemetry.powerSupplyVoltage / 12) * 100, 100);
  }

  getLastUpdate(car: Car): string | undefined {
    return car.telemetry?.updatedAt;
  }

  getProgressColor(value: number): string {
    if (value >= 70) return 'var(--dark-green-background)';
    if (value >= 30) return 'var(--background-progress-bar)';
    return 'var(--status-discharged-text)';
  }

  getStatusStyle(status: string): { background: string; color: string } {
    const map: Record<string, { background: string; color: string }> = {
      'AVAILABLE':    { background: 'var(--status-available-bg)',    color: 'var(--status-available-text)' },
      'IN_USE':       { background: 'var(--status-in-use-bg)',        color: 'var(--status-in-use-text)' },
      'RESERVED':     { background: 'var(--status-reserved-bg)',      color: 'var(--status-reserved-text)' },
      'MAINTENANCE':  { background: 'var(--status-maintenance-bg)',   color: 'var(--status-maintenance-text)' },
      'DISCHARGED':   { background: 'var(--status-discharged-bg)',    color: 'var(--status-discharged-text)' },
      'REBALANCING':  { background: 'var(--status-rebalancing-bg)',   color: 'var(--status-rebalancing-text)' },
    };
    return map[status] ?? { background: 'var(--status-reserved-bg)', color: 'var(--status-reserved-text)' };
  }

  timeAgo(dateStr: string | undefined): string {
    if (!dateStr) return '---';
    const diff = Date.now() - new Date(dateStr).getTime();
    const totalMins = Math.floor(diff / 60000);
    const days = Math.floor(totalMins / 1440);
    const hours = Math.floor((totalMins % 1440) / 60);
    const mins = totalMins % 60;
    const parts: string[] = [];
    if (days > 0) parts.push(`${days}d`);
    if (hours > 0) parts.push(`${hours}h`);
    if (mins > 0 || parts.length === 0) parts.push(`${mins}min`);
    return parts.join(' ') + ' ago';
  }

  openMaps(car: Car) {
    const lat = car.telemetry?.position?.latitude;
    const lng = car.telemetry?.position?.longitude;
    if (lat != null && lng != null) {
      window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`, '_blank');
    }
  }
}
